import { PaginationRequest } from '../config/common';

export class PaginationCountryRequest extends PaginationRequest {
    name?: string = '';
    iso?: string = '';
    vaTable?: boolean;
}
export interface CreateCountryRequest {
    name?: string;
    iso?: string;
    vaTable?: boolean;
}